import { HourglassEmpty, Refresh } from "@mui/icons-material";
import {
  Button,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Page from "../components/Page";
import { formatTime } from "../components/Time";
import { useGetLogsQuery } from "../data/business";

export default function Log() {
  const { data: logs, isLoading, refetch } = useGetLogsQuery();

  if (isLoading) {
    return <LinearProgress />;
  }

  if (!logs) {
    return (
      <Page title="Log">
        <HourglassEmpty />
      </Page>
    );
  }

  return (
    <Page title="Log">
      <Button
        variant="contained"
        color="primary"
        startIcon={<Refresh />}
        onClick={() => {
          refetch();
        }}
      >
        Refresh
      </Button>

      <TableContainer>
        <Table sx={{ width: "100%", maxWidth: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Code</TableCell>
              <TableCell>Error</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.timestamp}>
                <TableCell>{formatTime(log.timestamp)}</TableCell>
                <TableCell>{log.message || "-"}</TableCell>
                <TableCell>{log.code || "-"}</TableCell>
                <TableCell>{log.error || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Page>
  );
}
